import { useCallback, useMemo, memo } from 'react';
import classNames from 'classnames';
import './OptionSelector.scss';
import TrashIcon from '../../images/trash.svg';
import { QUANTITY_TYPES } from '../../config/config';

const OptionSelector = memo(({
  id,
  value = 0,
  endValue = 10,
  multiplier = 1,
  itemLabels = { [QUANTITY_TYPES.SINGULAR]: 'Item', [QUANTITY_TYPES.PLURAL]: 'Items' },
  allowNone = true,
  onChange,
}) => {
  const options = useMemo(() => {
    const generatedOptions = [];

    if (allowNone) {
      generatedOptions.push({ value: 0, label: '' });
    }

    const numberOfOptions = Math.floor(endValue / multiplier);
    const itemOptions = Array.from({ length: numberOfOptions }, (_, index) => {
      const optionValue = multiplier * (index + 1);
      const label = optionValue === 1
        ? `${optionValue} ${itemLabels[QUANTITY_TYPES.SINGULAR]}`
        : `${optionValue} ${itemLabels[QUANTITY_TYPES.PLURAL]}`;
      return { value: optionValue, label };
    });

    generatedOptions.push(...itemOptions);

    return generatedOptions;
  }, [allowNone, endValue, itemLabels, multiplier]);

  const handleOptionClick = useCallback((newValue) => {
    onChange?.(id, newValue);
  }, [id, onChange]);

  return (
    <div className="OptionSelector">
      <div className="OptionSelector__options">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            className={classNames('OptionSelector__option', {
              'OptionSelector__option--selected': value === option.value,
              'OptionSelector__option--none': option.value === 0,
            })}
            onClick={() => handleOptionClick(option.value)}
          >
            {option.value === 0 && allowNone && (
              <div className="OptionSelector__trash-icon">
                <img src={TrashIcon} alt="None" width={16} height={16} />
              </div>
            )}
            {option.label && (
              <span className="OptionSelector__option-text">
                {option.label}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
});

export default OptionSelector;
